const User = ({ size = 40, onClick }) => (
  <svg
    id="User"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    onClick={onClick}
  >
    <path
      d="M17.3247 34.52C25.4204 34.52 31.9834 27.9571 31.9834 19.8613C31.9834 11.7656 25.4204 5.20267 17.3247 5.20267C9.22892 5.20267 2.66602 11.7656 2.66602 19.8613C2.66602 27.9571 9.22892 34.52 17.3247 34.52Z"
      fill="#80D4DC"
    />
    <path
      d="M27.328 17.564C23.104 17.564 19.668 14.128 19.668 9.904C19.668 5.68 23.104 2.244 27.328 2.244C31.552 2.244 34.988 5.68 34.988 9.904C34.988 14.128 31.552 17.564 27.328 17.564ZM27.328 3.84267C23.9866 3.84267 21.268 6.56134 21.268 9.90267C21.268 13.244 23.9866 15.9627 27.328 15.9627C30.6693 15.9627 33.388 13.244 33.388 9.90267C33.388 6.56134 30.6693 3.84267 27.328 3.84267Z"
      fill="#5A348C"
    />
    <path
      d="M37.3334 37.7573C36.8921 37.7573 36.5334 37.3987 36.5334 36.9573V29.8613C36.5334 24.788 32.4027 20.6613 27.3254 20.6613C22.2481 20.6613 18.1254 24.788 18.1254 29.8613V36.9573C18.1254 37.3987 17.7667 37.7573 17.3254 37.7573C16.8841 37.7573 16.5254 37.3987 16.5254 36.9573V29.8613C16.5254 23.9067 21.3707 19.0613 27.3254 19.0613C33.2801 19.0613 38.1334 23.9067 38.1334 29.8613V36.9573C38.1334 37.3987 37.7747 37.7573 37.3334 37.7573Z"
      fill="#5A348C"
    />
  </svg>
);

export default User;
